import Component from '@glimmer/component';
import { service } from '@ember/service';
// empty component needs to be kept
//we have some preloading mechanisms of this component that require it
export default class SidebarRightMyworld extends Component {
  @service account;

  get flagTrendingHashtags() {
    return this.account.flagTrendingHashtags;
  }
}
